import { withLayout } from '../../../layout';

import RequestLogsPage from './request-logs.page';

export default withLayout(RequestLogsPage);
